import React from 'react';
import { Table, List } from 'antd';

import Popover from 'components/UI/Popover/Popover';
import styles from './ProductTable.module.css';

const renderFeature = data => {
  const length = 17;
  if (data.length < length) {
    return <span className={styles.Span}>{data}</span>;
  } else {
    return (
      <span className={styles.Span}>
        <Popover title="Feature" data={data} length={length} />
      </span>
    );
  }
};

const renderDimensions = data => (
  <List className={styles.List} size="small" dataSource={data} renderItem={item => <List.Item>{item}</List.Item>} />
);

const expandedRow = row => {
  const columns = [
    {
      title: 'Dimensions',
      dataIndex: 'dimensions',
      key: 'dimensions',
      width: 120,
      render: col => renderDimensions(col),
    },
    {
      title: 'Variation',
      dataIndex: 'variation',
      key: 'variation',
      width: 150,
    },
    {
      title: 'Stock',
      dataIndex: 'stock_level',
      key: 'stock_level',
      width: 100,
    },
    {
      title: 'Feature',
      dataIndex: 'feature',
      key: 'feature',
      width: 200,
      render: col => renderFeature(col),
    },
    {
      title: 'Remark',
      dataIndex: 'remark',
      key: 'remark',
    },
  ];
  return <Table columns={columns} dataSource={[row]} pagination={false} rowKey={record => record.id} />;
};

export default expandedRow;



// WEBPACK FOOTER //
// ./src/components/Product/ProductTable/ProductTableExtended.js